import React, { createContext, useContext, ReactNode } from 'react';

import { ApolloError } from '@apollo/client';

import useAllotmentCheck from 'checkout/hooks/use-allotment-check';
import { GqlAllotmentInfo } from 'types/graphql';

type AllotmentContextValue = {
  allotmentInfo: GqlAllotmentInfo | null;
  loading: boolean;
  error: ApolloError | undefined;
  isAllotmentExceeded: boolean;
  shouldShowAllotment: boolean;
};

const AllotmentContext = createContext<AllotmentContextValue>({
  allotmentInfo: null,
  loading: false,
  error: undefined,
  isAllotmentExceeded: false,
  shouldShowAllotment: false,
});

export function AllotmentProvider({ children }: { children: ReactNode }): JSX.Element {
  const allotmentState = useAllotmentCheck();
  return <AllotmentContext.Provider value={allotmentState}>{children}</AllotmentContext.Provider>;
}

export function useAllotment(): AllotmentContextValue {
  return useContext(AllotmentContext);
}
